import Cookies from "js-cookie";

/**
 * Get the GA4 client ID
 */
export const getClientId = (): string | undefined => {
    return Cookies.get("_ga")?.substring(6) || undefined;
};
